import { Component, inject, ViewChild } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '../../components/modal/modal.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { DropdownService } from '../../services/dropdown.service';
import { HeaderComponent } from "../../components/header/header.component";
import { SearchInputComponent } from "../../components/search-input/search-input.component";
import { ButtonComponent } from "../../components/button/button.component";
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { BulkUploadComponent } from "../../components/bulk-upload/bulk-upload.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { RolePermissionMappingService } from '../../services/role-permission-mapping.service';
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { UserService } from '../../services/user.service';
import { JsonPipe, NgIf } from '@angular/common';
import { ImageUploderComponent } from '../../components/image-uploder/image-uploder.component';
import { DateInputComponent } from '../../components/date-input/date-input.component';
import { ValidationService } from '../../services/validation.service';
import { FormService } from '../../services/form.service';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { FileUploaderComponent } from '../../components/file-uploader/file-uploader.component';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [HeaderComponent, SearchInputComponent, JsonPipe, RouterLink, ButtonComponent, FilterByKeyAndValuePipe, AgGridListComponent, ConfirmationPopupComponent, ModalComponent, TextInputComponent, BulkUploadComponent, ReactiveFormsModule, PluralPipe, FormsModule, SelectInputComponent, NgIf, ImageUploderComponent, DateInputComponent, FileUploaderComponent, FormsModule, DropdownUploadButtonComponent, ButtonComponent],
  templateUrl: './user-list.component.html',
})
export class UserListComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  page_name = 'User';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any = [];
  fs = inject(FormService);
  user_type = { user_type: 'staff' }
  showPasswordField: boolean = true;
  isSubmitting = false;
  show_menu = false;



  columns: any = [];

  bulk_columns = [
    // { column_name: 'Role', type: 'text', return_as: 'role_id', sample_value: 'Admin' },
    { column_name: 'Name', type: 'text', return_as: 'name', sample_value: 'AD', regex: this.vs.new_name_pattern, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, },
    // { column_name: 'Last Name', type: 'text', return_as: 'last_name', sample_value: 'AD' },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'faculty@example.com', strict_validation: 'email' },
    { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '9372740268', strict_validation: 'mobile' },
    { column_name: 'Password', type: 'text', return_as: 'password', sample_value: 'Admin@123', regex: this.vs.password_complex_pattern },
  ];

  bulk_columns_download: any = [];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Enable' : 'Disable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.user_management_faculty_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.user_management_faculty_view })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this), disabled: row.is_active === false, permissions: this.gs.user_role_data?.user_management_faculty_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this), permissions: this.gs.user_role_data?.user_management_faculty_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public us: UserService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      role_id: ['', [Validators.required]],
      university_id: ['', [Validators.required]],
      college_id: ['', [Validators.required]],
      subject_ids: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.new_name_pattern)]],
      email: ['', [Validators.required, Validators.pattern(this.vs.email_pattern), Validators.maxLength(this.vs.max_length_email)]],
      contact: ['', [Validators.required, Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact)]],
      password: ['', [Validators.required, Validators.pattern(this.vs.password_complex_pattern)]],
      image: [''],
      is_active: [true],
      user_type: 'staff'
    });
  }
  selectedRole: any = null;

  bulk_form: FormGroup = this.fb.group({
    role_id: ['', Validators.required],
    university_id: [''],
    college_id: [''],
    subject_ids: [''],
  });
  bulk_filtered_role: any = null;

  get bulk_extra_data() {
    const v = this.bulk_form.value;
    const data: any = { role_id: v.role_id };
    if (this.bulk_filtered_role?.belongs_to !== 'all') data.university_id = v.university_id;
    if (this.bulk_filtered_role?.belongs_to === 'college') data.college_id = v.college_id;
    if (this.bulk_filtered_role?.belongs_to === 'subject') data.subject_ids = v.subject_ids;
    return data;
  }

  onBulkRoleSelect(roleId: any) {
    this.bulk_filtered_role = this.ds.dropdown_list?.role_list?.find((r: any) => r.id === roleId) || null;
    this.bulk_form.patchValue({ university_id: '', college_id: '', subject_ids: '' });
    this.updateBulkValidators();
  }

  updateBulkValidators() {
    const uCtrl = this.bulk_form.get('university_id');
    const cCtrl = this.bulk_form.get('college_id');
    const sCtrl = this.bulk_form.get('subject_ids');
    uCtrl?.clearValidators(); cCtrl?.clearValidators(); sCtrl?.clearValidators();
    if (this.bulk_filtered_role?.belongs_to === 'university' || this.bulk_filtered_role?.belongs_to === 'college' || this.bulk_filtered_role?.belongs_to === 'subject') {
      uCtrl?.setValidators(Validators.required);
    }
    if (this.bulk_filtered_role?.belongs_to === 'college') cCtrl?.setValidators(Validators.required);
    if (this.bulk_filtered_role?.belongs_to === 'subject') sCtrl?.setValidators(Validators.required);
    uCtrl?.updateValueAndValidity(); cCtrl?.updateValueAndValidity(); sCtrl?.updateValueAndValidity();
  }

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['role', 'university', 'exam', 'subject', 'college', 'academic-year']);
    this.ar.queryParams.subscribe(params => {
      this.params = { ...params, user_type: 'staff' };
      this.filter_university_id = params['university_id'] || null;
      this.filter_role_id = params['role_id'] || null;
      this.page_name = 'Faculty';
      this.column_push()
      const user_type_params = { ...this.params, user_type: 'staff' };
      this.get_list(user_type_params)
    });
    this.form.get('role_id')?.valueChanges.subscribe(roleId => {
      this.selectedRole = this.ds.dropdown_list?.role_list
        ?.find((r: any) => r.id === roleId);
      this.updateDynamicValidators();
    });
    this.bulk_form.get('role_id')?.valueChanges.subscribe(roleId => {
      this.onBulkRoleSelect(roleId);
    });
    this.bulk_form.get('university_id')?.valueChanges.subscribe(() => {
      this.bulk_form.patchValue({ college_id: '', subject_ids: '' });
    });
  }

  column_push() {
    this.columns = [
      { headerName: 'User ID', field: 'SrNo', width: 90, minWidth: 90, maxWidth: 90 },
      {
        headerName: 'University', filter: true, flex: 1,
        valueGetter: (p: any) => p.data?.University?.name || '-',
      },
      { field: 'name', headerName: 'Name', filter: true, flex: 1 },
      {
        headerName: 'Role', filter: true, flex: 1,
        valueGetter: (p: any) => p.data?.Role?.name || '-',
      },
      {
        headerName: 'Contact', filter: true, flex: 2,
        cellStyle: { display: 'flex', alignItems: 'center' },
        valueGetter: (p: any) => [p.data?.contact, p.data?.email].filter(Boolean).join(', '),
        cellRenderer: (p: any) => {
          const contact = p.data?.contact || '';
          const email = p.data?.email || '';
          return `<div style="display:flex;flex-direction:column;justify-content:center;line-height:1.5">
            ${contact ? `<span style="font-weight:500;color:#111827;font-size:14px">${contact}</span>` : ''}
            ${email ? `<span style="color:#9CA3AF;font-size:13px">${email}</span>` : ''}
          </div>`;
        }
      },
      {
        headerName: 'Subject', filter: true, flex: 2,
        valueGetter: (p: any) => (p.data?.subjects || []).map((s: any) => s.code ? `${s.name} (${s.code})` : s.name).join(', ')
      },
      {
        field: 'image', headerName: 'Image Available', filter: true, flex: 1,
        cellRenderer: (p: any) => p.data?.image ? 'Yes' : 'No'
      },
      { headerName: "", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right' }
    ]

    this.bulk_columns_download = [
      { column_name: 'Role', download_bind: 'role_id', type: 'link', linked_list: 'role_list', linked_from: 'role', return_as: 'role_id', returning_key: 'id', sample_value: '1' },
      { column_name: 'Name', type: 'text', return_as: 'name', sample_value: 'AD' },
      { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: 'AD' },
      { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'Mumbai' },
      { column_name: 'University', type: 'text', download_bind: 'University.name', return_as: 'university_id', sample_value: '' },
      { column_name: 'Subject', download_bind: 'subject_ids', type: 'link', linked_list: 'subject_list', linked_from: 'subject', return_as: 'subject_ids', returning_key: 'id', sample_value: '1' },
      { column_name: 'Status', type: 'text', return_as: 'is_active', sample_value: 'Mumbai' },
      // { column_name: 'Academic Year', download_bind: 'academic_year_id', type: 'link', linked_list: 'academic_list', linked_from: 'academic-year', return_as: 'academic_year_id', returning_key: 'id', sample_value: '1' },
    ]
  }

  async get_list(filter?: any) {
    try {
      const finalFilter = { ...filter, user_type: 'staff' };
      const res = await this.us.get_list(finalFilter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;
      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: String(startindex + index + 1).padStart(3, '0')
      }));
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  async delete(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }

  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        const user_type = 'staff';
        let res = await this.us.delete(id);
        if (res != undefined) {
          this.gs.toastr_shows_function(res?.message, 'Success', 'success');
        }
      }
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_disable(ids: any[]) {
    try {
      for (let id of ids) {
        await this.us.update(id, { is_active: false, user_type: 'staff' });
      }
      this.gs.toastr_shows_function('Users disabled successfully', 'Success', 'success');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  open_form_modal(item?: any) {
    const targetId = item?.id || item?.user?.id || null;
    this.route.navigate(['/faculty/form'], {
      queryParams: targetId ? { id: targetId } : null
    });
  }

  open_view_modal(item: any) {
    const targetId = item?.id || item?.user?.id || null;
    this.route.navigate(['/faculty/form'], {
      queryParams: targetId ? { id: targetId, view: 'true' } : { view: 'true' }
    });
  }

  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.us.update(this.selected_ids.id, { is_active: data, user_type: 'staff' });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async disable_country() {
    const user_type = 'staff';
    let res = await this.us.delete(this.selected_ids?.id);
    if (res != undefined) {
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    }
    this.selected_ids = {};
    this.confirmation_delete_modal?.close()
    await this.get_list(this.params);
  }

  close_form_modal(): void {
    this.form_modal?.close();
  }

  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let payload: any = { ...this.form.value, user_type: 'staff' };
      payload.user_type = 'staff'
      delete payload.roll_number;
      delete payload.birth_date;
      delete payload.registration_number;
      delete payload.academic_year_id
      payload.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        if (!this.showPasswordField) {
          delete payload.password;
        }
        console.log(payload);

        // return
        let update_response = await this.us.update(this.selected_ids.id, payload);
        this.gs.toastr_shows_function(update_response.message, 'Success', 'success');
      } else {
        let create_response = await this.us.add(payload);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true,
        user_type: 'staff'
      }));
      await this.gs.bulk_form_submission(updatedData, this.us, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  updateDynamicValidators() {
    const universityControl = this.form.get('university_id');
    const collegeControl = this.form.get('college_id');
    const subjectControl = this.form.get('subject_ids');

    // Clear all validators first
    universityControl?.clearValidators();
    collegeControl?.clearValidators();
    subjectControl?.clearValidators();

    if (!this.selectedRole || this.selectedRole.belongs_to === 'all') {
      // all → no validation
    } else if (this.selectedRole.belongs_to === 'university') {
      // Only university required
      universityControl?.setValidators([Validators.required]);
    } else if (this.selectedRole.belongs_to === 'college') {
      // University and College required
      universityControl?.setValidators([Validators.required]);
      collegeControl?.setValidators([Validators.required]);
    } else if (this.selectedRole.belongs_to === 'subject') {
      // University and Subject required
      universityControl?.setValidators([Validators.required]);
      subjectControl?.setValidators([Validators.required]);
    }

    // Update validation state
    universityControl?.updateValueAndValidity();
    collegeControl?.updateValueAndValidity();
    subjectControl?.updateValueAndValidity();
  }

  getRowStyle = (params: any) => {
    if (params.data?.is_active === false) {
      return { background: '#F2F2F2', borderBottom: '1px solid #00000029' };
    }
    return {};
  };

  filter_university_id: any = null;
  filter_role_id: any = null;

  on_filter_change() {
    this.params = {
      ...this.params,
      university_id: this.filter_university_id || undefined,
      role_id: this.filter_role_id || undefined,
    };
    this.change_params();
  }

  change_params() {
    this.route.navigate([], {
      relativeTo: this.ar,
      queryParams: { ...this.params },
    });
  }

  resetPassword() {
    this.showPasswordField = true;

    this.form.get('password')?.reset();
    this.form.get('password')?.setValidators([
      Validators.required,
      Validators.pattern(this.vs.password_complex_pattern)
    ]);
    this.form.get('password')?.updateValueAndValidity();
  }

  hidePassword() {
    this.showPasswordField = false;

    this.form.get('password')?.clearValidators();
    this.form.get('password')?.reset();
    this.form.get('password')?.updateValueAndValidity();
  }

}
